import { ApolloClient, NormalizedCacheObject } from '@apollo/client/core'

import { strToFileExtension } from '../../strToFileExtension'
import { UploadDetails } from '../UploadDetails'
import { fetchHoleUpload } from '__generated__/fetchHoleUpload'
import { FETCH_HOLE_UPLOAD_QUERY } from '@base/api/queries/fetchHoleUpload'

export async function fetchHoleUpload(
  file: File,
  client: ApolloClient<NormalizedCacheObject>
): Promise<UploadDetails | false> {
  try {
    const { data } = await client.query<fetchHoleUpload>({
      query: FETCH_HOLE_UPLOAD_QUERY,
      variables: {
        fileExtension: strToFileExtension(file.type)
      },
      fetchPolicy: 'no-cache'
    })
    if (data.fetchHoleUpload.__typename !== 'FetchUploadOutput') {
      return false
    }
    const { url, fields } = data.fetchHoleUpload.upload
    return {
      url,
      fields: fields.map((field) => ({ key: field.key, value: field.value }))
    }
  } catch (e) {
    console.error(e)
    return false
  }
}
